<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-ready-to-deliver`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M44 2a2 2 0 012 2v14a2 2 0 01-2 2v3h-4v-3H8v20h14v4H6a2 2 0 01-2-2V20a2 2 0 01-2-2V4a2 2 0 012-2h40zm-8 22c6.627 0 12 5.373 12 12s-5.373 12-12 12-12-5.373-12-12 5.373-12 12-12zm-8 12a8 8 0 1116 0 8 8 0 01-16 0zm9-6a1 1 0 011 1v3h3a1 1 0 011 1v2a1 1 0 01-1 1h-6a1 1 0 01-1-1v-6a1 1 0 011-1h2zM6 6h36v10H6V6z"/></svg>
</template>
<script>

export default {
  name: 'IconReadyToDeliver',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
